module.exports = __webpack_public_path__ + "static/assets/8a3162f801b365f46843f075d9a5410f.svg";